import React from 'react';
import './FilterMarket.css';

export function FilterMarket({ selectedMarket, selectedNetwork, selectedMember }) {
  return (
    <div className='responsive-table'>
        <div className='select-filter'>
            <label>Market</label>
            <select 
                className='select-filter__market' 
                onChange={selectedMarket}
            >
                <option >Select</option>
                <option value="AZURE">AZURE</option>
                <option value="RED HAT">RED HAT</option>
                <option value="GOOGLE">GOOGLE</option>
                <option value="AWS">AWS</option>
            </select>

            <label>Network</label>
            <select 
                className='select-filter__network' 
                onChange={selectedNetwork}
            >
                <option >Select</option>
                <option value="MainNet">MainNet</option>
                <option value="Open Protestnet">Open Protestnet</option>
            </select>

            <label>Membership</label>
            <select 
                className='select-filter__membership' 
                onChange={selectedMember}
            >
                <option >Select</option>
                <option value="Basic">Basic</option>
                <option value="Standard">Standard</option>
                <option value="Premium">Premium</option>
            </select>
        </div>
    </div>
  );
}

